/**
 * The role label shown beside the customer name in the header (the "· CDI"
 * suffix).
 *
 * Provisionally a static label, matching arc. It may later be derived from the
 * user's group/role once that signal is defined; this accessor is the single seam
 * to swap when it is, so the header composition never reads the label directly.
 */
export const useRoleLabel = (): string => 'CDI'
